import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, RefreshCw, Loader2, Save } from "lucide-react";
import { toast } from "sonner";

const WA_LABEL = {
    sent: "WhatsApp ile gönderildi",
    failed: "WhatsApp gönderilemedi",
    no_credit: "WhatsApp kontürü yok",
    not_sent: "WhatsApp gönderilmedi",
};

export const WeeklySummaryCard = () => {
    const [data, setData] = useState(null);
    const [phone, setPhone] = useState("");
    const [busy, setBusy] = useState(false);

    const load = () =>
        api.get("/clinic/weekly-summary").then((r) => {
            setData(r.data);
            setPhone(r.data.summary_phone || "");
        });

    useEffect(() => {
        load().catch(() => {});
    }, []);

    async function regenerate() {
        setBusy(true);
        try {
            await api.post("/clinic/weekly-summary/generate");
            await load();
            toast.success("Haftalık özet hazırlandı");
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setBusy(false);
        }
    }

    async function savePhone() {
        try {
            await api.put("/clinic/summary-phone", { phone });
            toast.success("WhatsApp numarası kaydedildi");
        } catch (e) {
            toast.error(formatApiError(e));
        }
    }

    if (!data) return null;
    const s = data.summary;
    return (
        <Card className="mb-8 overflow-hidden" data-testid="weekly-summary-card">
            <CardContent className="p-6">
                <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#00A896] to-[#0F4C5C] text-white flex items-center justify-center">
                            <Sparkles className="w-5 h-5" />
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold text-slate-900">Haftalık Özet</h2>
                            <p className="text-xs text-slate-500">
                                Her cuma 20:00'de yapay zeka hazırlar{s ? ` • ${s.period}` : ""}
                                {s && ` • ${WA_LABEL[s.whatsapp_status] || ""}`}
                            </p>
                        </div>
                    </div>
                    <Button variant="outline" size="sm" onClick={regenerate} disabled={busy} data-testid="weekly-summary-generate-btn">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-1" />}
                        Şimdi hazırla
                    </Button>
                </div>
                {s ? (
                    <div className="dd-md text-sm text-slate-700 whitespace-pre-line bg-slate-50 rounded-xl p-4 border border-slate-100" data-testid="weekly-summary-text">
                        <ReactMarkdown>{s.text.replace(/(^|\s)\*([^*\n]+)\*/g, "$1**$2**")}</ReactMarkdown>
                    </div>
                ) : (
                    <p className="text-sm text-slate-500" data-testid="weekly-summary-empty">Henüz özet yok. İlk özet cuma 20:00'de hazırlanacak ya da "Şimdi hazırla"ya basabilirsiniz.</p>
                )}
                <div className="mt-4 flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-slate-500">Özetin gönderileceği WhatsApp numarası:</span>
                    <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="05XX XXX XX XX"
                        className="h-8 w-44 text-sm" data-testid="weekly-summary-phone-input" />
                    <Button size="sm" variant="ghost" onClick={savePhone} data-testid="weekly-summary-phone-save-btn">
                        <Save className="w-4 h-4 mr-1" /> Kaydet
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};
